import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GainMoreCustomersState } from './typings'
import { getData, postData } from './api'
import { StoreData } from '@user/store/reducers/typings'
import { updateAssigneeIdsNullValue } from '@user/components/Dashboard/widgets/utils/updateAssigneeIdsNullValue'

export const initialState: GainMoreCustomersState = {
  assigneeId: null,
  assigneeIds: [],
  data: {
    capturedLeads: 0,
    openLeads: 0,
    openLeadsValue: 0,
    openOpportunities: 0,
    openOpportunitiesValue: 0,
    salesTeamId: null,
    salesTeamIds: [],
    salesTeamName: null,
    salesTeamNames: null,
    assigneeId: null,
    assigneeIds: [],
    assigneeName: null,
    assigneeNames: null,
    branches: null,
  },
  isLoading: false,
  salesTeamId: null,
  salesTeamIds: [],
  showFront: true,
}

const gainMoreCustomersSlice = createSlice({
  name: 'dashboard/gainMoreCustomers',
  initialState: initialState,
  reducers: {
    flipCard: (state: GainMoreCustomersState) => {
      state.showFront = !state.showFront
    },
    setSalesTeamId: (
      state: GainMoreCustomersState,
      { payload }: PayloadAction<number | null>,
    ) => {
      state.salesTeamId = payload
    },
    setSalesTeamsIds: (
      state: GainMoreCustomersState,
      { payload }: PayloadAction<number[]>,
    ) => {
      state.salesTeamIds = payload
    },
    setAssigneeId: (
      state: GainMoreCustomersState,
      { payload }: PayloadAction<string | null>,
    ) => {
      state.assigneeId = payload
    },
    setAssigneeIds: (
      state: GainMoreCustomersState,
      { payload }: PayloadAction<string[]>,
    ) => {
      state.assigneeIds = payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getData.fulfilled, (state, { payload }) => {
      payload.assigneeIds = updateAssigneeIdsNullValue(payload.assigneeIds)
      state.assigneeId = payload.assigneeId
      state.assigneeIds = payload.assigneeIds
      state.salesTeamId = payload.salesTeamId
      state.salesTeamIds = payload.salesTeamIds
      state.data = payload
    })
    builder.addCase(postData.fulfilled, (state, { payload }) => {
      state.assigneeId = payload.assigneeId
      state.salesTeamId = payload.salesTeamId
    })
  },
})

export const selectGainMoreCustomers = (state: StoreData) => {
  return state.dashboard.gainMoreCustomers
}

export const {
  flipCard,
  setAssigneeId,
  setAssigneeIds,
  setSalesTeamId,
  setSalesTeamsIds,
} = gainMoreCustomersSlice.actions
export const reducer = gainMoreCustomersSlice.reducer
